<div class="container">
  <div class="services_heading">
    <span>Our Customers Tell Their Own Story</span>
    <p>
      We are proud to be helping people across the UK save money on their household bills.
    </p>
  </div>
  <div class="trustpilot-widget" data-locale="en-GB" data-template-id="54ad5defc6454f065c28af8b"
    data-businessunit-id="5a05e3ce0000ff0005b01862" data-style-height="240px" data-style-width="100%" data-theme="light"
    data-stars="4,5" data-review-languages="en">
    <a href="https://uk.trustpilot.com/review/dontwastemoney.co.uk" target="_blank" rel="noopener">Trustpilot</a>
  </div>
</div>